<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="userId" :label="$t('作者用户ID')">
        <a-input v-model="form.userId"  :placeholder="$t('请输入')+$t('作者用户ID')" />
      </a-form-model-item>
      <a-form-model-item prop="authorName" :label="$t('作者昵称快照')">

        <a-input v-model="form.authorName" :maxLength="100" :placeholder="$t('请输入')+$t('作者昵称快照')" />
      </a-form-model-item>
      <a-form-model-item prop="title"  :label="$t('帖子标题')">
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('请输入')+$t('帖子标题')" />
      </a-form-model-item>
      <a-form-model-item prop="content" :label="$t('帖子内容')">
        <editor v-model="form.content" />
      </a-form-model-item>
<!--      <a-form-model-item prop="contentType" :label="$t('内容类型')">

      </a-form-model-item>-->
      <a-form-model-item prop="mediaUrls" :label="$t('素材URL')" >
        <oss-upload-multi :is-array-data="true" :max-count="10" :disabled="true" v-model="form.mediaUrls" prefix="goods" type="img" />
      </a-form-model-item>
<!--      <a-form-model-item prop="isRecommend" :label="$t('是否推荐')">
        <a-input v-model="form.isRecommend"  :placeholder="$t('请输入')+$t('是否推荐')" />
      </a-form-model-item>-->
      <a-form-model-item prop="shelfStatus" :label="$t('上架状态')">
        <custom-dict-tag :options="customDict.PostShelfStatusEnum" :value="form.shelfStatus"/>
      </a-form-model-item>
      <a-form-model-item prop="postStatus" :label="$t('帖子状态')">
        <custom-dict-tag :options="customDict.PostStatusEnum" :value="form.postStatus"/>
<!--        <span slot="label" >
          <a-tooltip>
            帖子状态 0-草稿箱 1-机审中 2-人工审核 3-机审拒绝 4-人审拒绝 5-举报下架 6-发布成功 7-主动下架<template slot="title">帖子状态 0-草稿箱 1-机审中 2-人工审核 3-机审拒绝 4-人审拒绝 5-举报下架 6-发布成功 7-主动下架</template>
          </a-tooltip>
        </span>-->
      </a-form-model-item>
<!--      <a-form-model-item prop="machineStatus" :label="$t('机审结果')">
&lt;!&ndash;        <span slot="label" >
          <a-tooltip>
            机审结果 0-未触发 1-处理中 2-通过 3-疑似 4-拒绝<template slot="title">机审结果 0-未触发 1-处理中 2-通过 3-疑似 4-拒绝</template>
          </a-tooltip>
        </span>&ndash;&gt;
      </a-form-model-item>
      <a-form-model-item prop="machineScore" :label="$t('机审分数')">
&lt;!&ndash;        <span slot="label" >
          <a-tooltip>
            机审分数<template slot="title">机审分数</template>
          </a-tooltip>
        </span>&ndash;&gt;
        <a-input v-model="form.machineScore"  :placeholder="$t('请输入')+$t('机审分数')" />
      </a-form-model-item>
      <a-form-model-item prop="machineLabels" :label="$t('机审标签')">
&lt;!&ndash;        <span slot="label" >
          <a-tooltip>
            机审标签<template slot="title">机审标签</template>
          </a-tooltip>
        </span>&ndash;&gt;
        <a-input v-model="form.machineLabels" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="humanStatus" :label="$t('人审结果')">
&lt;!&ndash;        <span slot="label" >
          <a-tooltip>
            人审结果 0-未审 1-通过 2-拒绝<template slot="title">人审结果 0-未审 1-通过 2-拒绝</template>
          </a-tooltip>
        </span>&ndash;&gt;
      </a-form-model-item>-->
      <a-form-model-item prop="rejectReason" :label="$t('拒绝下架原因')">
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            拒绝/下架原因<template slot="title">拒绝/下架原因</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
        <a-input v-model="form.rejectReason" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="publishTime" :label="$t('发布时间')">
<!--        <span slot="label" >
          <a-tooltip>
            发布时间<template slot="title">发布时间</template>
          </a-tooltip>
        </span>-->
        <a-date-picker style="width: 100%" v-model="form.publishTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="viewCnt" :label="$t('浏览量')">
<!--        <span slot="label" >
          <a-tooltip>
            浏览量<template slot="title">浏览量</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.viewCnt"  :placeholder="$t('请输入')+$t('浏览量')" />
      </a-form-model-item>
      <a-form-model-item prop="commentCnt" :label="$t('评论量')">
<!--        <span slot="label" >
          <a-tooltip>
            评论量<template slot="title">评论量</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.commentCnt"  :placeholder="$t('请输入')+$t('评论量')" />
      </a-form-model-item>
      <a-form-model-item prop="likeCnt" :label="$t('点赞量')">
<!--        <span slot="label" >
          <a-tooltip>
            点赞量<template slot="title">点赞量</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.likeCnt"  :placeholder="$t('请输入')+$t('点赞量')" />
      </a-form-model-item>
      <a-form-model-item prop="collectCnt" :label="$t('收藏量')">
<!--        <span slot="label" >
          <a-tooltip>
            收藏量<template slot="title">收藏量</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.collectCnt"  :placeholder="$t('请输入')+$t('收藏量')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" :label="$t('备注')">
<!--        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>-->
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDiscoveryPost, addDiscoveryPost, updateDiscoveryPost } from '@/api/discovery/discoveryPost'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'
import OssUploadMulti from "@/components/OssUploadMulti/index.vue";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadMulti,
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        authorName: null,

        title: null,

        content: null,

        contentType: null,

        mediaUrls: null,

        isRecommend: null,

        shelfStatus: 0,

        postStatus: 0,

        machineStatus: 0,

        machineScore: null,

        machineLabels: null,

        humanStatus: 0,

        rejectReason: null,

        publishTime: null,

        viewCnt: null,

        commentCnt: null,

        likeCnt: null,

        collectCnt: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '作者用户ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        authorName: [
          { required: true, message: '作者昵称快照'+this.$t('不能为空'), trigger: 'blur' }
        ],
        title: [
          { required: true, message: '帖子标题'+this.$t('不能为空'), trigger: 'blur' }
        ],
        contentType: [
          { required: true, message: '内容类型 1-图文 2-视频'+this.$t('不能为空'), trigger: 'change' }
        ],
        isRecommend: [
          { required: true, message: '是否推荐 1-是 0-否'+this.$t('不能为空'), trigger: 'blur' }
        ],
        shelfStatus: [
          { required: true, message: '上架状态 0-下架 1-上架'+this.$t('不能为空'), trigger: 'blur' }
        ],
        postStatus: [
          { required: true, message: '帖子状态 0-草稿箱 1-机审中 2-人工审核 3-机审拒绝 4-人审拒绝 5-举报下架 6-发布成功 7-主动下架'+this.$t('不能为空'), trigger: 'blur' }
        ],
        machineStatus: [
          { required: true, message: '机审结果 0-未触发 1-处理中 2-通过 3-疑似 4-拒绝'+this.$t('不能为空'), trigger: 'blur' }
        ],
        machineScore: [
          { required: true, message: '机审分数'+this.$t('不能为空'), trigger: 'blur' }
        ],
        machineLabels: [
          { required: true, message: '机审标签'+this.$t('不能为空'), trigger: 'blur' }
        ],
        humanStatus: [
          { required: true, message: '人审结果 0-未审 1-通过 2-拒绝'+this.$t('不能为空'), trigger: 'blur' }
        ],
        rejectReason: [
          { required: true, message: '拒绝/下架原因'+this.$t('不能为空'), trigger: 'blur' }
        ],
        viewCnt: [
          { required: true, message: '浏览量'+this.$t('不能为空'), trigger: 'blur' }
        ],
        commentCnt: [
          { required: true, message: '评论量'+this.$t('不能为空'), trigger: 'blur' }
        ],
        likeCnt: [
          { required: true, message: '点赞量'+this.$t('不能为空'), trigger: 'blur' }
        ],
        collectCnt: [
          { required: true, message: '收藏量'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        authorName: null,
        title: null,
        content: null,
        contentType: null,
        mediaUrls: null,
        isRecommend: null,
        shelfStatus: 0,
        postStatus: 0,
        machineStatus: 0,
        machineScore: null,
        machineLabels: null,
        humanStatus: 0,
        rejectReason: null,
        publishTime: null,
        viewCnt: null,
        commentCnt: null,
        likeCnt: null,
        collectCnt: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDiscoveryPost({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateDiscoveryPost(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addDiscoveryPost(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
